import { Flex } from 'antd'
import { SearchItem } from 'shared/common/Header/ui/SearchItem/Universal'

import React from 'react'

import {
  useGetSearchAutoCompleteQuery,
  useGetSearchQueriesQuery,
} from 'modules/Search/model/api'

import { Divider } from 'shared/ui/divider'
import { Loader } from 'shared/ui/loader'

import { useDebounce } from 'shared/hooks/useDebounce'

import styles from './SearchDropdown.module.scss'

interface SearchDropdownProps {
  searchQuery: string
  withoutAutoComplete?: boolean
  type?: 'mobile' | 'desktop'
}

export function SearchDropdown({
  searchQuery,
  withoutAutoComplete = false,
  type = 'desktop',
}: SearchDropdownProps) {
  const debouncedQuery = useDebounce(searchQuery, 200)

  const { data, isLoading } = useGetSearchQueriesQuery()
  const { data: autoComplete } = useGetSearchAutoCompleteQuery(
    {
      query: debouncedQuery,
    },
    { skip: !debouncedQuery || withoutAutoComplete },
  )

  const suggestions = autoComplete?.suggestions
  const searchQueries = [
    {
      label: 'Вы искали',
      items: data?.search_history,
      withDelete: true,
    },
    {
      label: 'Часто ищут',
      items: data?.most_searched,
      withDelete: false,
    },
  ]
  if (isLoading) {
    return (
      <div className={styles.loaderWrapper}>
        <Loader />
      </div>
    )
  }
  if (!!suggestions?.length) {
    return (
      <div className={styles.searchDropdown}>
        {suggestions.map((suggestion, index) => (
          <SearchItem
            isMobile={type === 'mobile'}
            key={index}
            id={index}
            withDelete={false}
            label={suggestion}
          />
        ))}
      </div>
    )
  }

  return (
    <div className={styles.searchDropdown}>
      {searchQueries.map(({ items, label, withDelete }, index, arr) => {
        if (!items?.length) return null
        return (
          <React.Fragment key={label}>
            <Flex className={styles.searchWrapper} vertical gap={8}>
              <span className={styles.label}>{label}</span>
              <Flex vertical gap={2}>
                {items?.map(({ pk, query }) => (
                  <SearchItem
                    isMobile={type === 'mobile'}
                    key={pk}
                    id={pk}
                    label={query}
                    withDelete={withDelete}
                  />
                ))}
              </Flex>
            </Flex>
            {index !== arr.length - 1 && (
              <Divider type="horizontal" margin="medium" />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}
